<template>
  <CContainer class="pt-5 mb-5" fluid>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">APHT Payment</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item to="/invoice-apht/created">
            <CIcon name="cil-credit-card" />
            Created
          </b-breadcrumb-item>
          <b-breadcrumb-item active>Detail</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <b-card no-body>
          <b-tabs card v-model="tabsIndex">
            <b-tab title="PNBP" @click="redirectPage('pnbp')" :disabled="$helper.isEmpty(details.invoiceNoPnbp)">
              <CRow class="mx-2">
                <CCol class="col-12 col-md-6 p-1">
                  <CCard class="custom-form-card custom-card">
                    <CCardBody>
                      <CRow>
                        <CCol class="col-12">
                          <h5 class="custom-header-display">Data Invoice</h5>
                        </CCol>
                        <CCol class="col-12 pt-2 custom-detail-list">
                          <CRow v-if="isLoadingAPHT">
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                          </CRow>
                          <CRow v-else>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>Tipe Kontrak</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: APHT</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>No. Invoice</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: {{ $helper.showData(details.invoiceNoPnbp, "string") }}</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>No. Receive</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: {{ $helper.showData(details.receiveNo, "string") }}</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>Status Bayar</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: {{ $helper.showData(details.paymentStatusDisplay, "string") }}</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>Tanggal Appl.</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: {{ $helper.showData(details.applicationDate, "shortDate") }}</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>Tanggal Bayar</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: {{ $helper.showData(details.paymentDate, "shortDate") }}</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>Total Bayar</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: Rp {{ $helper.showData(details.totalPayment, "number") }}</p>
                            </CCol>
                          </CRow>
                        </CCol>
                      </CRow>
                    </CCardBody>
                  </CCard>
                </CCol>
                <CCol class="col-12 col-md-6 p-1">
                  <CCard class="custom-form-card custom-card">
                    <CCardBody>
                      <CRow>
                        <CCol class="col-12">
                          <h5 class="custom-header-display">Data FIFApps</h5>
                        </CCol>
                      </CRow>
                      <CRow>
                        <CCol class="pt-2 custom-detail-list">
                          <CRow v-if="isLoadingAPHT">
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                          </CRow>
                          <CRow v-else>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                              <p>ID Vendor</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                              <p>: {{ $helper.showData(details.vendorId, "string") }}</p>
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                              <p>Nama Vendor</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                              <p>: {{ $helper.showData(details.vendorName, "string") }}</p>
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                              <p>Bank Vendor</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                              <p>: {{ $helper.showData(details.vendorBank, "string") }}</p>
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                              <p>Akun Bank Vendor</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                              <p>: {{ $helper.showData(details.vendorBankAccount, "string") }}</p>
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                              <p>Nama Akun Bank</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                              <p>: {{ $helper.showData(details.vendorAccountName, "string") }}</p>
                            </CCol>
                        </CRow>
                        </CCol>
                      </CRow>
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>
            </b-tab>
            <b-tab title="Notaris" @click="redirectPage('notary')" :disabled="$helper.isEmpty(details.invoiceNoNotary)">
              <CRow class="mx-2">
                <CCol class="col-12 col-md-6 p-1">
                  <CCard class="custom-form-card custom-card">
                    <CCardBody>
                      <CRow>
                        <CCol class="col-12">
                          <h5 class="custom-header-display">Data Invoice</h5>
                        </CCol>
                        <CCol class="col-12 pt-2 custom-detail-list">
                          <CRow v-if="isLoadingAPHT">
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                          </CRow>
                          <CRow v-else>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>Tipe Kontrak</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: APHT</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>No. Invoice</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: {{ $helper.showData(details.invoiceNoNotary, "string") }}</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>No. Receive</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: {{ $helper.showData(details.receiveNo, "string") }}</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>Status Bayar</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: {{ $helper.showData(details.paymentStatusDisplay, "string") }}</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>Tanggal Appl.</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: {{ $helper.showData(details.applicationDate, "shortDate") }}</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>Tanggal Bayar</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: {{ $helper.showData(details.paymentDate, "shortDate") }}</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                              <p>Total Bayar</p>
                            </CCol>
                            <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                              <p>: Rp {{ $helper.showData(details.totalPayment, "number") }}</p>
                            </CCol>
                          </CRow>
                        </CCol>
                      </CRow>
                    </CCardBody>
                  </CCard>
                </CCol>
                <CCol class="col-12 col-md-6 p-1">
                  <CCard class="custom-form-card custom-card">
                    <CCardBody>
                      <CRow>
                        <CCol class="col-12">
                          <h5 class="custom-header-display">Data FIFApps</h5>
                        </CCol>
                      </CRow>
                      <CRow>
                        <CCol class="pt-2 custom-detail-list">
                          <CRow v-if="isLoadingAPHT">
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                              <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                            </CCol>
                          </CRow>
                          <CRow v-else>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                              <p>ID Vendor</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                              <p>: {{ $helper.showData(details.vendorId, "string") }}</p>
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                              <p>Nama Vendor</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                              <p>: {{ $helper.showData(details.vendorName, "string") }}</p>
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                              <p>Bank Vendor</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                              <p>: {{ $helper.showData(details.vendorBank, "string") }}</p>
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                              <p>Akun Bank Vendor</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                              <p>: {{ $helper.showData(details.vendorBankAccount, "string") }}</p>
                            </CCol>
                            <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                              <p>Nama Akun Bank</p>
                            </CCol>
                            <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                              <p>: {{ $helper.showData(details.vendorAccountName, "string") }}</p>
                            </CCol>
                        </CRow>
                        </CCol>
                      </CRow>
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>
            </b-tab>
          </b-tabs>
        </b-card>
      </CCol>
    </CRow>
    <!-- <CRow class="mt-4" style="text-align: center;">
      <CCol>
        <CButton color="primary" @click="downloadPDFInvoice" :disabled="isLoadingAPHT || isDownloading.downloadPDFInvoice">
          <b-spinner small v-if="true.downloadPDFInvoice" />
          {{ isDownloading.downloadPDFInvoice ? 'Sedang diproses...' : 'Download PDF Invoice' }}
        </CButton>
      </CCol>
    </CRow> -->
  </CContainer>
</template>


<script>
export default {
  name: 'InvoiceApprovedDetail',
  data() {
    let idx = 0
    if(this.$route.params.invoiceType == 'pnbp') idx = 0
    else if(this.$route.params.invoiceType == 'notary') idx = 1
    return {

      isLoadingAPHT: true,
      details: {
        invoiceNoPnbp: "-",
        invoiceNoNotary: "-"
      },

      tabsIndex: idx,

      isSubmitting: {
        updateAPHT: false,
        reviseAPHT: false,
        updateApproval: false
      },
      isDownloading: {
        downloadPDFInvoice: false,
      },

      approval: [],
      updateApprovalModalData: {
        isShowing: false,
        table: {
          isLoaded: false,
          fields: [
            {key: "level", label: "Level", sortable: false},
            {key: "approveBy", label: "Approve By", sortable: false},
            {key: "values", label: "Value", sortable: false},
            {key: "minPokokPembiayaan", label: "Min Pokok Pembiayaan", sortable: false},
            {key: "action", label: "", sortable: false}
          ],

          items: [],

          validationItems: [],

          template: {
            approveBy: "jobCode",
            level: 1,
            minPokokPembiayaan: 0,
            values: []
          },

          validationTemplate: {
            minPokokPembiayaan: {
              isValid: null,
              feedback: 'This input is required.',
              isRequired: true,
              payloadKey: "minPokokPembiayaan"
            },
            values: {
              isValid: null,
              feedback: 'This input is required.',
              isRequired: true,
              payloadKey: "values"
            },
          },

          approveByOptions: [
            { value: "jobCode", text: "Job Code" },
            { value: "user", text: "User" },
          ],

          jobCodeData: {
            isLoaded: false,
            isValid: null,
            isRequired: true,
            options: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            lastQuery: '',
          },

          userData: {
            isLoaded: false,
            isValid: null,
            isRequired: true,
            options: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            lastQuery: '',
          },

          currentPage: 1,
        },
        isSubmitting: false
      },

    }
  },
  methods: {
    redirectPage(sourceTab) {
      if(sourceTab == this.$route.params.invoiceType) return

      let collateralId = this.$route.params.collateralId
      let invoiceType = this.$route.params.invoiceType == 'pnbp' ? 'notary' : 'pnbp'
      this.$router.push({ name: 'Invoice APHT Approved Detail', params: { invoiceType: invoiceType, collateralId: collateralId} })
      this.getAPHT()
    },

    getAPHT(){
      this.isLoadingAPHT = true
      let getUrl = "/aphtPayment/getInvoiceDetail"
      let params = {}
      params['invoiceType'] = this.$route.params.invoiceType
      params['collateralAphtId'] = this.$route.params.collateralId
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        return this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.details = response.data.data
            this.details.paymentStatusDisplay = "-"
            if(this.details.paymentStatus == "U") {
              this.details.paymentStatusDisplay = "UNPAID"
            }
            else if(this.details.paymentStatus == "P") {
              this.details.paymentStatusDisplay = "PAID"
            }
          }
          else{
            this.$helper.toastError(this, "Load Detail Invoice Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Detail Invoice Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Detail Invoice Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.isLoadingAPHT = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    downloadPDFInvoice() {
      this.isDownloading.downloadPDFInvoice = true
      let postUrl = "/aphtPayment/createInvoiceFile"
      let data = new FormData()
      if (this.$route.params.invoiceType == 'pnbp') {
        data.set('invoiceNo', this.details.invoiceNoPnbp)
      } else{
        data.set('invoiceNo', this.details.invoiceNoNotary)
      }
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.post(postUrl, data).then(response => {
          if(response.status == 200){
            window.open(response.data.data, "_blank")
            window.focus()
            this.$helper.toastSuccess(this, "Download Invoice Sukses! " + (response.data.reason ? response.data.reason : ""))
          } else{
            this.$helper.toastError(this, "Download Invoice Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Download Invoice Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Download Invoice Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.isDownloading.downloadPDFInvoice = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    }
  },

  computed:{
  },

  mounted(){
    this.getAPHT().then(_ => {
      if(this.$helper.isEmpty(this.details.invoiceNoPnbp)){
        this.tabsIndex = 1
      }
      else if(this.$helper.isEmpty(this.details.invoiceNoNotary)){
        this.tabsIndex = 0
      }
      else{
        if(this.$route.params.invoiceType == 'pnbp') this.tabsIndex = 0
        else if(this.$route.params.invoiceType == 'notary') this.tabsIndex = 1
      }
    })
  }
}
</script>

<style scoped>
  .card-header .nav-item a {
    color: white;
  }
  .card.custom-card {
    min-height: 300px !important;
  }
  .card.notes-card {
    border-bottom: 5px solid hsl(210, 3%, 85%) !important;
  }
  thead {
    font-weight: 500;
  }
  .table-semicolon {
    min-width: 30px; 
    text-align: center;
  }
</style>
